// Currency composable matching backend ISO 4217 implementation
import { ref } from "vue";

// ISO 4217 currencies with 0 decimal places
const ZERO_DECIMAL_CURRENCIES = [
  "BIF",
  "CLP",
  "DJF",
  "GNF",
  "ISK",
  "JPY",
  "KMF",
  "KRW",
  "PYG",
  "RWF",
  "UGX",
  "UYI",
  "VND",
  "VUV",
  "XAF",
  "XAG",
  "XAU",
  "XBA",
  "XBB",
  "XBC",
  "XBD",
  "XDR",
  "XOF",
  "XPD",
  "XPF",
  "XPT",
  "XSU",
  "XTS",
  "XUA",
  "XXX",
];

// ISO 4217 currencies with 3 decimal places
const THREE_DECIMAL_CURRENCIES = [
  "BHD",
  "IQD",
  "JOD",
  "KWD",
  "LYD",
  "OMR",
  "TND",
];

const currency = ref(localStorage.getItem("currency") || "EUR");

/**
 * Get the number of decimal places for a currency according to ISO 4217
 */
export const getCurrencyDecimals = (code = currency.value) => {
  if (ZERO_DECIMAL_CURRENCIES.includes(code)) {
    return 0;
  }
  if (THREE_DECIMAL_CURRENCIES.includes(code)) {
    return 3;
  }
  return 2; // Default for most currencies
};
